// test2371
(2371 && 0);
